import { render, staticRenderFns } from "./CopyAddBranch.vue?vue&type=template&id=49724780&scoped=true"
import script from "./CopyAddBranch.vue?vue&type=script&lang=js"
export * from "./CopyAddBranch.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CopyAddBranch.vue?vue&type=style&index=1&id=49724780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49724780",
  null
  
)

export default component.exports